module.exports = __webpack_public_path__ + "static/img/3.05ab51c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/zh/3.png
// module id = UDLO
// module chunks = 0